import React, { useEffect, useRef } from 'react';
import anime from 'animejs/lib/anime.es.js';

const AnimationOverlay = ({ show }) => {
  // Create a ref to target the overlay for animations
  const overlayRef = useRef(null);

  useEffect(() => {
    // Check if the ref is correctly assigned before attempting to animate
    if (overlayRef.current) {
      anime({
        targets: overlayRef.current,
        opacity: show ? 1 : 0, // Toggle opacity based on `show`
        easing: 'easeOutQuad',
        duration: 1000,  // Adjust duration as needed, 1000 ms = 1 second
        begin: function() {
          overlayRef.current.style.display = 'block'; // Ensure the overlay is visible before animation starts
        },
        complete: function() {
          // Hide the overlay completely after fading out
          if (!show) {
            overlayRef.current.style.display = 'none';
          }
        }
      });
    }
  }, [show]); // Re-run the effect when the value of `show` changes

  return (
    <div ref={overlayRef} style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: '#1e1806',
      zIndex: 50,
      opacity: 1, // Start with fully opaque
      pointerEvents: 'none',
    }} />
  );
};

export default AnimationOverlay;